module.exports = __webpack_public_path__ + "static/media/4.5f74bab5.jpg";